import { render, staticRenderFns } from "./textbook.vue?vue&type=template&id=66a058a8&scoped=true&"
import script from "./textbook.vue?vue&type=script&lang=js&"
export * from "./textbook.vue?vue&type=script&lang=js&"
import style0 from "./textbook.vue?vue&type=style&index=0&id=66a058a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a058a8",
  null
  
)

export default component.exports